import axios from "common/helpers/axios.helper"
import * as iconsApi from "common/api/icons.api"

export const initIcon = (data, modalDialog) => {
    return (dispatch) => {
        dispatch({ type: 'ICON_INIT', payload: data });
        if (modalDialog) {
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: modalDialog, type: 'create' } });
        }
    }
}

export function setIconList(icons) {
    return {
        type: "SET_ICON_LIST",
        payload: icons
    }
}

export const getIconList = () => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'ICON_LIST_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/icons/${currentContainer}`),
            method: 'GET',
            responseType: 'json',
            headers: { 'authorization': token, 'Content-Type': 'application/json' }
        }).then((response) => {
            dispatch({ type: 'ICON_LIST_SUCCESS', payload: response.data });
        }).catch((error) => {
            dispatch({ type: 'ICON_LIST_ERROR', payload: error.response });
        });
    }
}

export const getIcon = (id, modalDialog = null, modalType = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'ICON_SELECT_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/icons/${currentContainer}/id/${id}`),
            method: 'GET',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'ICON_SELECT_SUCCESS', payload: response.data });
            if (modalDialog) {
                dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: modalDialog, type: modalType } });
            }
        }).catch((error) => {
            dispatch({ type: 'ICON_SELECT_ERROR', payload: error.response });
        });
    }
}

export const createIcon = (data) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'ICON_CREATE_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/icons/${currentContainer}`),
            method: 'POST',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            data: data,
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'ICON_CREATE_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
            dispatch(getIconList())
        }).catch((error) => {
            dispatch({ type: 'ICON_CREATE_ERROR', payload: error.response });
        });
    }
}

export const updateIcon = (id, data) => {
    return (dispatch) => {
        dispatch({ type: 'ICON_UPDATE_PENDING' });

        iconsApi.update(data)
        .then(response => {
            dispatch({ type: 'ICON_UPDATE_SUCCESS', payload: response.data });
            setTimeout(() => dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } }), 1000);
            dispatch(getIconList())
        }).catch((error) => {
            dispatch({ type: 'ICON_UPDATE_ERROR', payload: error.response });
        });
    }
}

export const deleteIcon = (id) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'ICON_DELETE_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/icons/${currentContainer}/id/${id}`),
            method: 'DELETE',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'ICON_DELETE_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
            dispatch(getIconList())
        }).catch((error) => {
            dispatch({ type: 'ICON_DELETE_ERROR', payload: error.response });
        });
    }
}

